<script>
import XdslLineIntention from "./XdslLineIntention.vue";

export default {
    name: "XdslLineIntentionPopin",
    components: { XdslLineIntention },
    props: {
        dtoFromJson: {
            type: String,
            required: false,
            default: ""
        },
        dtoFromObject: {
            type: Object,
            required: false,
            default: undefined
        },
        xdslLineIntentions: {
            type: Array,
            required: false,
            default: undefined
        }
    },
    computed: {
        /**
         * @returns {XdslLineIntentionPopinDto}
         */
        dto() {
            return typeof this.dtoFromObject === "object" && this.dtoFromObject || JSON.parse(this.dtoFromJson)
        },
        title() {
           return this.dto.title
        },
        pageTitle() {
            return this.dto.pageTitle
        },
        pageType() {
            return this.dto.pageType
        },
        popinModal() {
            return this.dto.popinModal
        },
        popinClassName() {
            return this.dto.popinClassName
        },
        intentions() {
            return this.xdslLineIntentions !== undefined ? this.xdslLineIntentions : this.dto.intentions
        }
    },
    mounted() {
        $('#' + this.popinModal.id).on('show.bs.modal', function (e) {
            $('.modal.show').not(e.target).modal('hide');
        });
    }
}
</script>

<template>
    <!--/* POPIN */-->
    <ob1-popin-modal2
        :id="popinModal.id"
        :aria-labelledby="popinModal.label"
        :show-close-button="popinModal.showCloseButton"
        :class="popinClassName"
    >
        <section
            :data-titre-page="pageTitle"
            :data-type-page="pageType"
        >
            <h3>{{ title }}</h3>
            <xdsl-line-intention
                :intentions-from-object="intentions"
                :parent-container-id="popinModal.id"
            />
        </section>
    </ob1-popin-modal2>
</template>
